import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { UnstyledButton, Flex, Text, Box, Badge } from "@mantine/core";
import { AnimatePresence, motion } from "framer-motion";

import { getDataFromNhtsaResults } from "./helpers";

export default function NhtsaResults({ results = {} }) {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  const formattedItems = results.response
    ? getDataFromNhtsaResults(results.response)
    : [];

  const hasResults =
    JSON.stringify(results.response) !== "{}" &&
    JSON.stringify(results.response) !== undefined;

  return (
    <div>
      <Box
        component={UnstyledButton}
        onClick={() => {
          if (!hasResults) return;
          setOpen(!isOpen);
        }}
      >
        <Flex gap="xs" direction="column">
          <Flex gap="xs" align="center">
            <Text c={results.success ? "green" : "red"} fw={600} size="xl">
              NHTSA
            </Text>
            <Badge
              // leftSection={
              //   results.success ? (
              //     <IconCheck style={{ width: "60%", height: "60%" }} />
              //   ) : (
              //     <IconX style={{ width: "60%", height: "60%" }} />
              //   )
              // }
              size="xs"
              // color={results.success ? "green" : "red"}
              c={results.success ? "green" : "red"}
              bg={results.success ? "green.1" : "red.1"}
            >
              {results.success
                ? t("mixer:vehicle:nhtsa_results_success")
                : t("mixer:vehicle:nhtsa_results_needs_attention")}
            </Badge>
          </Flex>
        </Flex>
        {hasResults ? (
          <Text size="xs" c="dimmed">
            {t("mixer:vehicle:toggle_nhtsa_results_text", {
              action: isOpen ? "hide" : "see",
            })}
          </Text>
        ) : (
          <Text size="xs" c="dimmed">
            {t("mixer:vehicle:nhtsa_results_not_available")}
          </Text>
        )}
      </Box>
      {hasResults && (
        <Box
          mt="xs"
          style={{
            background: "var(--mantine-color-dark-6)",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid var(--mantine-color-dark-5)",
            borderTop: results.success
              ? "3px solid var(--mantine-color-green-7)"
              : "3px solid var(--mantine-color-red-7)",
            // borderBottom: results.success
            //   ? "3px solid var(--mantine-color-green-7)"
            //   : "3px solid var(--mantine-color-red-7)",
            // border: results.success
            //   ? "2px solid var(--mantine-color-green-7)"
            //   : "2px solid var(--mantine-color-red-7)",
          }}
        >
          {formattedItems.map((m, i) => (
            <div key={i}>
              <Text c="white">
                {m.text}: {m.value || "?"}
              </Text>
            </div>
          ))}
          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -10, opacity: 0 }}
                transition={{ duration: 0.15 }}
              >
                <Box mt="xs">
                  {results.response
                    .filter((f) => f.Variable === "Error Text")
                    .map((m, i) => (
                      <Text key={i} c="white">
                        {m.Value.replace("0 - ", "")}
                      </Text>
                    ))}
                </Box>
                {/* <Box
                mt="xs"
                style={{
                  background: "var(--mantine-color-dark-6)",
                  padding: "10px",
                  borderRadius: "6px",
                  border: results.success
                    ? "1px solid var(--mantine-color-green-5)"
                    : "1px solid var(--mantine-color-red-5)",
                }}
              >
                <Text mb="xs" c="white" fw={600} size="sm">
                  NHTSA Results
                </Text>
                {results.response
                  .filter((f) => f.Variable === "Error Text")
                  .map((m, i) => (
                    <Text key={i} c="white">
                      {m.Value.replace("0 - ", "")}
                    </Text>
                  ))}
              </Box> */}
              </motion.div>
            )}
          </AnimatePresence>
        </Box>
      )}
    </div>
  );
}
